export default "__VITE_ASSET__BLAGjyuR__"